import React from 'react';

function Numeral({ value }) {
  return <p>{value || 0}</p>;
}

export default Numeral;
